
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Logo et description */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="flex items-center">
                <span className="text-2xl font-bold text-orange-500">FMS</span>
                <div className="w-6 h-6 ml-2 flex items-center justify-center">
                  <i className="ri-wifi-line text-blue-500 text-xl"></i>
                </div>
              </div>
              <div className="text-sm text-gray-300">
                Protec
              </div>
            </div>
            <p className="text-gray-300 text-sm mb-4">
              Solutions de sécurité électronique pour particuliers et PME
            </p>
            <p className="text-orange-400 font-medium text-sm">
              "LA SÉRÉNITÉ AU-DEHORS ET LA SÉCURITÉ AU DEDANS"
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Nos Services</h3>
            <ul className="space-y-2 text-gray-300 text-sm">
              <li className="flex items-center">
                <i className="ri-shield-check-line text-orange-500 mr-2"></i>
                Contrôle d'accès
              </li>
              <li className="flex items-center">
                <i className="ri-alarm-warning-line text-orange-500 mr-2"></i>
                Systèmes d'alarme
              </li>
              <li className="flex items-center">
                <i className="ri-eye-line text-orange-500 mr-2"></i>
                Protection intrusion
              </li>
              <li className="flex items-center">
                <i className="ri-fire-line text-orange-500 mr-2"></i>
                Sécurité incendie
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <div className="space-y-3 text-gray-300 text-sm">
              <div className="flex items-center">
                <i className="ri-phone-line text-orange-500 mr-3"></i>
                <a href="tel:0484660814" className="hover:text-orange-400 transition-colors cursor-pointer">
                  0484 66 08 14
                </a>
              </div>
              <div className="flex items-center mb-4">
                <i className="ri-mail-line text-orange-500 mr-3"></i>
                <a 
                  href="mailto:fms.protec@gmail.com" 
                  className="hover:text-orange-400 transition-colors cursor-pointer"
                >
                  fms.protec@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-6 text-center text-gray-400 text-sm">
          <p>&copy; 2024 FMS Protec - Fondée par Maxime Fragapane. Tous droits réservés. | 
            <a href="https://readdy.ai/?origin=logo" className="hover:text-orange-400 transition-colors ml-1 cursor-pointer">
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
